module.exports = __webpack_public_path__ + "static/media/General_settings.85d80928.svg";